import { render, staticRenderFns } from "./WisdomAgri.vue?vue&type=template&id=b0b6fe7c&"
import script from "./WisdomAgri.vue?vue&type=script&lang=js&"
export * from "./WisdomAgri.vue?vue&type=script&lang=js&"
import style0 from "./WisdomAgri.vue?vue&type=style&index=0&id=b0b6fe7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports